import ElaborazioniBatch from "..";

const routes = [
	{ name: "ElaborazioniBatchPage", path: "/elaborazionibatch", component: ElaborazioniBatch.ElaborazioniBatchPage },
	{ name: "ElaborazioniBatchPageElaborazioni", path: "/elaborazionibatch/elaborazioni", component: ElaborazioniBatch.ElaborazioniBatchElaborazioniListPage },
	{ name: "ElaborazioniBatchPageFiles", path: "/elaborazionibatch/files", component: ElaborazioniBatch.ElaborazioniBatchFilesPage },
];

export default routes;
